import WebService from "@/plugins/WebService";
import EnvService from "@/plugins/EnvService";

export default class LoggerHelper {
  static ctx;
  static webService;
  static logCentralInfo;
  static logLevel;
  static myIp=null;
  static uuid;

  static initLogger(ctx)
  {
    this.ctx = ctx;
    this.webService = new WebService(ctx);
    this.uuid=LoggerHelper.uuidv4();
    this.logCentralInfo=LoggerHelper.loggingInfo();
  }

  static doLog(myLogLevel)
  {
    var retVal=false;

    var level=this.logCentralInfo.logLevels.find(logLevel => logLevel.level === myLogLevel);
    var actualLevel=this.logCentralInfo.logLevels.find(logLevel => logLevel.level === this.logLevel);
    if (level.id==0)
      retVal=false;
    else
    {
      retVal=(level.id<=actualLevel.id) ? true : false;
    }

    return retVal;
  }

  static logEvent(logLevel, message, dump)
  {
    if (LoggerHelper.doLog(logLevel))
    {
      // create message log entry
      var logEntry= {
        appId: LoggerHelper.appId,
        env: EnvService.dataTargetEnvironment,
        sessionId: LoggerHelper.uuid,
        ip: LoggerHelper.myIp,
        ts: Date.now(),
        logLevel: logLevel,
        message: message,
        dump: LoggerHelper.getJSONDump(dump)
      };

      if (this.logCentralInfo.connectionType!='Console')
      {
        this.webService
        .createMessageLogEntry(this.ctx.$store.getters.createMessageLogEntry, logEntry)
        .then(response => {
          if (response.request.status != 201)
          {
            console.log(response.request.status)
          }
        })
        .catch(err => {
          console.log(err)
        });
      }
      else
        console.log(logEntry);
    }
  }

  static get logLevel()
  {
    return this.logLevel;
  }

  static get appId() {
    return "sdb";
  }

  static get levelOff()
  {
    return this.logCentralInfo.logLevels.find(logLevel => logLevel.level === "off").level;
  }

  static get levelFatal()
  {
    return this.logCentralInfo.logLevels.find(logLevel => logLevel.level === "fatal").level;
  }

  static get levelError()
  {
    return this.logCentralInfo.logLevels.find(logLevel => logLevel.level === "error").level;
  }

  static get levelWarn()
  {
    return this.logCentralInfo.logLevels.find(logLevel => logLevel.level === "warn").level;
  }

  static get levelInfo()
  {
    return this.logCentralInfo.logLevels.find(logLevel => logLevel.level === "info").level;
  }

  static get levelDebug()
  {
    return this.logCentralInfo.logLevels.find(logLevel => logLevel.level === "debug").level;
  }

  static get levelTrace()
  {
    return this.logCentralInfo.logLevels.find(logLevel => logLevel.level === "trace").level;
  }

  static get loggerInitialized()
  {
    return this.logCentralInfo===undefined ? false : true;
  }

  static loggingInfo()
  {
    this.webService
    .getLoggingInfo(this.ctx.$store.getters.getLogInfo, LoggerHelper.appId, EnvService.dataTargetEnvironment)
    .then(response => {
      this.logCentralInfo=Object.assign({}, response.data);
      this.logLevel=response.data.logLevel;
      LoggerHelper.setIp();
    })
    .catch(err => {
      console.log(err)
    });
  }

  static setIp()
  {
    if (LoggerHelper.myIp===null)
    {
      this.webService
      .getIp("https://www.cloudflare.com/cdn-cgi/trace")
      .then(response => {
        let ipRegex = /ip=(\S+)/
        LoggerHelper.myIp = response.data.match(ipRegex)[1];
      })
      .catch(err => {
        console.log(err);
      });
    }
  }

  static uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

  static getJSONDump(dump)
  {
    try
    {
      let s=JSON.stringify(dump);
      let o=JSON.parse(s);
      if (o && typeof o === "object")
        return s;
      else
        return JSON.stringify({});
    }      
    catch (err)
    {
      console.log(err);
      return JSON.stringify({});
    }
  }
}
